import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { useNavigate } from 'react-router-dom';
import DsModal from './ds/molecules/DsModal';
import Btn from './ds/atoms/btn';
import BtnEdit from './ds/atoms/btn/btnEdit';
import { setAvailabilityMinStay, increaseStayLength } from '../actions/Booking';

const SearchMinStay = (props, context) => {
  const navigate = useNavigate();
  const { minStay } = props;

  const onCustomSearch = () => {
    navigate('/');
    props.dispatch(setAvailabilityMinStay(0));
  };

  const onModifyDates = () => {
    props.dispatch(increaseStayLength(minStay, navigate));
    props.dispatch(setAvailabilityMinStay(0));
  };

  if (minStay === 0) {
    return null;
  }

  return (
    <DsModal onClose={onCustomSearch}>
      <section className="p-4">
        <h2 className="text-base text-primary uppercase">
          {context.t('Minimum stay {minStay} nights', { minStay })}
        </h2>
        <p>
          {context.t('For your better experience, the minimum stay of this hotel is {minStay} days', { minStay })}
        </p>
        <p>
          {context.t('We have adjusted it for you. Do you want to have a look?')}
        </p>
        <div className="flex justify-between -mx-2 mt-3">
          <BtnEdit className="mx-2" onClick={onCustomSearch}>
            {context.t("I'll do it myself")}
          </BtnEdit>
          <Btn className="mx-2 text-primary font-bold text-sm" iconBefore="check-tick" onClick={onModifyDates}>
            {context.t('OK, show me')}
          </Btn>
        </div>
      </section>
    </DsModal>
  );
};

SearchMinStay.propTypes = {
};

SearchMinStay.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  minStay: state.booking.availMinStay,
}))(SearchMinStay);
